import React from 'react';
import NetworkCircuitDetails from './components/NetworkCircuitDetails';
import RegisterDetails from './components/RegisterDetails';
import DeviceType from 'features/POSRegisters/interfaces/DeviceType';
import ScanDetails from 'features/POSRegisters/interfaces/ScanDetails';

interface DeviceDetailsProps {
  deviceType: DeviceType;
  scanResults: Partial<ScanDetails>;
}

export default function DeviceDetails({deviceType, scanResults: scanDetails}: DeviceDetailsProps) {
  switch (deviceType) {
    case 'cloudServices':
      return null;
    case 'networkCircuit':
      return <NetworkCircuitDetails {...scanDetails} />;
    default:
      return <RegisterDetails {...scanDetails} deviceType={deviceType} />;
  }
}
